import {Routes} from 'react-router-dom';
import {buildLazyRoute} from 'routes/LazyRoutes';
import {IS_PRODUCTION} from 'utils/general';

/**
 * Routes that ONLY show up in the development environment. A good place to host
 * storybook files and other testing tools.
 */
export default function GlobalDevelopmentOnlyRoutes() {
  if (IS_PRODUCTION) {
    return (
      <Routes>
        {buildLazyRoute({
          path: '*',
          loader: () => import('components/errors/Page404'),
          name: 'Page404',
          componentProps: {
            courseId: 'public',
          },
        })}
      </Routes>
    );
  }
  return (
    <Routes>
      {buildLazyRoute({
        path: 'test/services',
        loader: () => import('routes/FirebaseSmokePage'),
      })}
      {buildLazyRoute({
        path: 'test/studentBootstrap',
        loader: () => import('routes/StudentBootstrapPage'),
      })}
      {buildLazyRoute({
        path: 'loading',
        loader: () => import('components/loading/Loading'),
        name: 'Loading',
      })}
      {buildLazyRoute({
        path: 'loading-preview',
        loader: () => import('routes/dev/LoadingPreview'),
      })}
      {buildLazyRoute({
        path: 'slides-table-harness',
        loader: () => import('routes/dev/SlidesTableHarnessPreview'),
      })}
      {buildLazyRoute({
        path: 'morph-harness',
        loader: () => import('routes/dev/MorphHarnessPreview'),
      })}
      {buildLazyRoute({
        path: 'dice-demo-preview',
        loader: () => import('routes/dev/DiceDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'bayes-demo-preview',
        loader: () => import('routes/dev/BayesDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'word-likelihood-demo-preview',
        loader: () => import('routes/dev/WordLikelihoodDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'eikosogram-demo-preview',
        loader: () => import('routes/dev/EikosogramDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'monty-hall-demo-preview',
        loader: () => import('routes/dev/MontyHallDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'tree-demo-preview',
        loader: () => import('routes/dev/TreeDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'simpson-demo-preview',
        loader: () => import('routes/dev/SimpsonDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'venn-demo-preview',
        loader: () => import('routes/dev/VennDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'venn-contrast-preview',
        loader: () => import('routes/dev/VennContrastPreview'),
      })}
      {buildLazyRoute({
        path: 'venn-marginal-preview',
        loader: () => import('routes/dev/VennMarginalPreview'),
      })}
      {buildLazyRoute({
        path: 'galton-demo-preview',
        loader: () => import('routes/dev/GaltonDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'monte-carlo-demo-preview',
        loader: () => import('routes/dev/MonteCarloDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'clt-demo-preview',
        loader: () => import('routes/dev/CltDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'buffon-demo-preview',
        loader: () => import('routes/dev/BuffonDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'birthday-demo-preview',
        loader: () => import('routes/dev/BirthdayDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'prisoners-demo-preview',
        loader: () => import('routes/dev/PrisonersDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'card-counting-demo-preview',
        loader: () => import('routes/dev/CardCountingDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'ucb-demo-preview',
        loader: () => import('routes/dev/UcbDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'fourier-demo-preview',
        loader: () => import('routes/dev/FourierDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'chaos-pendulum-demo-preview',
        loader: () => import('routes/dev/ChaosPendulumDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'life-demo-preview',
        loader: () => import('routes/dev/LifeDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'sync-demo-preview',
        loader: () => import('routes/dev/SyncDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'times-table-demo-preview',
        loader: () => import('routes/dev/TimesTableDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'eigen-demo-preview',
        loader: () => import('routes/dev/EigenDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'llm-internals-demo-preview',
        loader: () => import('routes/dev/LlmInternalsDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'data-dump-demo-preview',
        loader: () => import('routes/dev/DataDumpDemoPreview'),
      })}
      {buildLazyRoute({
        path: 'code-viewer-panel-preview',
        loader: () => import('routes/dev/CodeViewerPanelPreview'),
      })}
      {buildLazyRoute({
        path: '404',
        loader: () => import('components/errors/Page404'),
        name: 'Page404',
        componentProps: {
          message: 'A test 404 page.',
          courseId: 'devtest',
        },
      })}
      {buildLazyRoute({
        path: 'noaccess',
        loader: () => import('components/errors/NoAccess'),
        name: 'NoAccess',
        componentProps: {
          message: 'A test no access page.',
          courseId: 'devtest',
        },
      })}
      {buildLazyRoute({
        path: 'error',
        loader: () => import('components/errors/ErrorPage'),
        name: 'ErrorPage',
        componentProps: {
          title: 'An example error page.',
          msg: 'This is a test error message.',
          courseId: 'devtest',
        },
      })}
      {buildLazyRoute({
        path: 'error',
        loader: () => import('components/errors/ErrorPage'),
        name: 'ErrorPage',
        componentProps: {
          title: 'An example error page.',
          msg: 'This is a test error message.',
          courseId: 'devtest',
        },
      })}
      {buildLazyRoute({
        path: 'error-boundary',
        loader: () => import('components/errors/AlwaysFailingPage'),
      })}
      {buildLazyRoute({
        path: 'wait-standard',
        loader: () => import('course/aboutcourse/WaitPage'),
        name: 'StandardUnenrolledPage',
        componentProps: {
          courseId: 'devtest',
          courseName: 'Example Course',
        },
      })}
      {buildLazyRoute({
        path: 'wait-live',
        loader: () => import('course/aboutcourse/WaitPage'),
        name: 'LiveCourseAdvertisement',
        componentProps: {
          courseId: 'devtest',
          courseName: 'Example Course',
          isStudentAppOpen: true,
          isSlAppOpen: true,
        },
      })}
      {buildLazyRoute({
        path: 'example-form',
        loader: () => import('components/Forms/ExampleForm'),
      })}
      {buildLazyRoute({
        path: 'waiting-room-chat',
        loader: () => import('routes/dev/WaitingRoomChatPreview'),
      })}
      {buildLazyRoute({
        path: 'waiting-room',
        loader: () => import('routes/dev/WaitingRoomFullPreview'),
      })}
      {buildLazyRoute({
        path: '*',
        loader: () => import('components/errors/Page404'),
        name: 'Page404',
        componentProps: {
          courseId: 'devtest',
        },
      })}
    </Routes>
  );
}
